<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :pageMode="true"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/sos_request";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "user_payload",
      "factory",
      "contact_person",
      "contact_for",
      "status",
      "assignee",
      "updated_at",
      "created_at",
    ],
  }),
};
</script>